__turbopack_context__.v({
  "content": "lHw72G_content",
});
